module.exports = __webpack_public_path__ + "media/images/sales/smakon/thumb-pricing-02-e79febf80e182bf82bfa22fcfd92a5de.svg";